export default "__VITE_ASSET__8ec0c3fd__"